import Link from 'next/link'
import React from 'react'
import type { IImageAssetV2 } from 'type/asset'
import type { IExploresCommunityV2 } from 'type/feed'
import SearchItem from '../dropdown-card/search-item'
import { Image } from 'component/ui/image'
import IconCommunity from 'asset/icon/home/us_s.svg'
import LoadingItems from 'component/block/loading/items'

interface ICommunitiesListProp {
  communities: IExploresCommunityV2[]
  loading: boolean
  LoadingCount?: number
  viewBoxValue?: string
}

const CommunitiesList = ({
  communities,
  loading,
  LoadingCount = 5,
  viewBoxValue = '0 0 600 350'
}: ICommunitiesListProp) => {
  return (
    <>
      {loading && (
        <LoadingItems count={LoadingCount} viewBoxValue={viewBoxValue} />
      )}
      {!loading &&
        communities?.map((community, index) => {
          const communityImageUrl = (community.asset as IImageAssetV2)
            ?.image_metadata[0]?.display_url

          return (
            <Link
              key={`community${index}`}
              href={`/community/${community.community_id}`}
              className='block py-[6px] hover:bg-background-2nd cursor-pointer'
            >
              <SearchItem
                title={community.title}
                prefix={
                  <Image
                    className='relative'
                    src={communityImageUrl}
                    alt='communityImageUrl'
                    fill={true}
                    fallback={
                      <IconCommunity className='fill-current sq-[24px]' />
                    }
                  />
                }
                description={community.description}
                iconShape='square'
              />
            </Link>
          )
        })}
    </>
  )
}

export default CommunitiesList
